import { ISpotifyPlayer } from '../types/spotify';
import { loadScript } from '../utils/loadScript';
import appService from './appService';

class SpotifyPlayerService {
    player!: ISpotifyPlayer;
    private name = '1Playlist';
    deviceId = '';
    disconnect() {
        if (this.player) {
            this.player.disconnect();
            this.player.removeListener('ready');
        }
    }
    init(accessToken: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            try {
                window.onSpotifyWebPlaybackSDKReady = () => {
                    this.player = new window.Spotify.Player({
                        getOAuthToken: (callback: (token: string) => void) => {
                            callback(accessToken);
                        },
                        name: this.name,
                        volume: 0.5,
                    }) as ISpotifyPlayer;
                    console.log('this.player', this.player);
                    this.player.connect();
                    console.log('this.player after connect', this.player);
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    this.player.addListener('ready', ({ device_id }) => {
                        console.log('The Web Playback SDK is ready to play music!');
                        // eslint-disable-next-line @typescript-eslint/camelcase
                        this.deviceId = device_id;
                        resolve(true);
                    });

                    this.player.addListener('not_ready', error => {
                        console.log('error not ready');
                        console.log('error', error);
                    });

                    this.player.addListener('account_error', error => {
                        console.log('error account error');
                        console.log('error', error);
                    });

                    this.player.addListener('initialization_error', error => {
                        console.log('error initialization error');
                        console.log('error', error);
                    });

                    this.player.addListener('playback_error', error => {
                        console.log('error playback error');
                        console.log('error', error);
                    });

                    this.player.addListener('authentication_error', async error => {
                        console.log('authentication_error', error);
                        try {
                            // TODO: There's an error on token lambda function
                            // Refactor this to show a modal and confirm to log in again
                            if (error.message) {
                                const response = await appService.refreshSpotifyUserAccessToken();
                                if (response.status === 200) {
                                    // window.location.href = '/';
                                }
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    });

                    // TODO: on account_error to validate spotify premium account
                };
                loadScript({
                    id: 'spotify-player',
                    source: 'https://sdk.scdn.co/spotify-player.js',
                });
            } catch (error) {
                console.log('error', error);
                reject(false);
            }
        });
    }
}

export default new SpotifyPlayerService();
